export const environment = {
  production: true,
  apiURL: 'https://coursekit-sciculture.eu/api',
  appURL: 'https://coursekit-sciculture.eu',
  wssURL: 'wss://coursekit-sciculture.eu:8080',
  appVersion: 'original', // original, lite, engaged
  showPopup: false , // only for dev
  neverShowSurveyPopup: true, // true or false
  gtagID: 'G-S75NC0JYGG'
};
